import { StackProps, Text, VStack } from "@chakra-ui/react";

interface Props extends StackProps {
  title: string;
  subtitle?: string;
}

export const ModalTitle = ({ title, subtitle, ...rest }: Props) => {
  return (
    <VStack w={"100%"} p={4} gap={0} textAlign={"center"} {...rest}>
      <Text textStyle={"h-reg-title"}>{title}</Text>
      {subtitle && (
        <Text textStyle={"b-sm"} variant={"secondary"}>
          {subtitle}
        </Text>
      )}
    </VStack>
  );
};
